var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.796377 17.5052C0.903439 17.6049 1.02897 17.6722 1.16107 17.7076C1.46035 17.7878 1.79302 17.704 2.0188 17.4615L7.96265 11.0759C8.28247 10.7323 8.79802 10.641 9.21621 10.8541L13.6331 13.1033C14.6267 13.6091 15.8221 13.4755 16.6792 12.7631L22.2677 8.11807L21.8479 12.8721C21.8104 13.2969 22.0865 13.677 22.4846 13.7836C22.5325 13.7964 22.5823 13.8053 22.6334 13.8098C23.1092 13.8519 23.529 13.5002 23.5711 13.0243L24.1846 6.07712C24.2048 5.84862 24.1333 5.62145 23.986 5.4456C23.8387 5.26972 23.6275 5.15957 23.399 5.13944L16.7176 4.54945C16.2418 4.50742 15.8219 4.85912 15.7799 5.33493C15.7379 5.8108 16.0897 6.23051 16.5654 6.27262L21.2807 6.68902L15.5735 11.4327C15.2483 11.703 14.7949 11.7537 14.4181 11.5618L10.0012 9.31258C8.89877 8.75115 7.53955 8.99147 6.69646 9.89722L0.752599 16.2829C0.427146 16.6325 0.446706 17.1798 0.796377 17.5052Z",
    fill: "#3A36DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.a30a0d438157d2789fddf499b1a91298.svg";
export { ForwardRef as ReactComponent };